import { render, staticRenderFns } from "./VendorInfoModal.vue?vue&type=template&id=565cc97a&scoped=true&"
import script from "./VendorInfoModal.vue?vue&type=script&lang=js&"
export * from "./VendorInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565cc97a",
  null
  
)

export default component.exports